import React from 'react';
import AncillaryRow from './AncillaryRow';
import AncillaryList from './AncillaryList';
import * as TFF from '@tff/types/TFF';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';
import TFFDivider from '../../styled-components/TFFDivider';

interface props {
  passenger: TFF.Passenger;
  passengerNr: number;
  ancillaries: TFF.Ancillaries;
  isOutbound: boolean;
  bookingSource?: TFF.TffBookingSource;
  orderDetails?: TFF.OrderDetails;
  journey?: TFF.Journey;
}

const PassengerRow: React.FC<props> = ({
  isOutbound,
  passengerNr,
  passenger,
  ancillaries,
  bookingSource,
  orderDetails,
  journey,
}) => {
  const intl = useIntl();

  const journeyExtra = passenger.JourneyExtras?.[isOutbound ? 0 : 1];

  const isInfantPossible =
    (passenger.Type !== 'INF' && journeyExtra?.Infant && ancillaries[journeyExtra.Infant]) || null;

  const isSeatPossible = (passenger.Type !== 'INF' && journeyExtra?.Seat && ancillaries[journeyExtra.Seat]) || null;

  const isSsrPossible = (passenger.Type !== 'INF' && journeyExtra?.Ssrs?.length) || null;

  return (
    <div>
      <div style={{ marginBottom: '4px' }}>
        <TFFTypography
          text={` ${intl.formatMessage({ id: 'ancillaries.passenger' })} ${
            passenger.Type == 'INF' ? passengerNr + ' - Infant' : passengerNr
          } - ${passenger.FirstName}
              ${passenger.LastName}`}
          color="color-concept-tuiblue"
          fontWeight="semibold"
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {passenger.Type === 'INF' ? (
          <TFFTypography
            text={`${intl.formatMessage({ id: 'ancillary.infant' })}`}
            color="color-functional-neutral-600"
          />
        ) : (
          <>
            <AncillaryList
              passenger={passenger}
              isSsrPossible={!!isSsrPossible}
              isSeatPossible={!!isSeatPossible}
              journeyExtras={journeyExtra}
              ancillaries={ancillaries}
              isOutbound={isOutbound}
              bookingSource={bookingSource}
              orderDetails={orderDetails}
              journey={journey}
            />
          </>
        )}
        {(isInfantPossible || isSeatPossible) && (
          <>
            {(journeyExtra?.Ssrs?.length ?? 0) > 0 && <TFFDivider />}
            {isInfantPossible && (
              <AncillaryRow
                ancillary={ancillaries[journeyExtra!.Infant!]}
                isOutbound={isOutbound}
                bookingSource={bookingSource}
              />
            )}
            {isSeatPossible && (
              <AncillaryRow
                ancillary={ancillaries[journeyExtra!.Seat!]}
                isOutbound={isOutbound}
                bookingSource={bookingSource}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PassengerRow;
